<template>
  <div class="p-b-5">
    <v-table
      :data="formattedReferences"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            :custom-sort="typeSort"
            default-sort="asc"
            v-t="'BUYER_REFERENCES_TABLE_TYPE'"
          >
          </v-th>
          <v-th 
            sort-key="name"
            v-t="'BUYER_REFERENCES_TABLE_NAME'"
          >
          </v-th>
          <th v-t="'BUYER_REFERENCES_TABLE_ID'">
          </th>
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>{{ row.type }}</td>
          <td>
            <a
              rel="noopener"
              target="_blank"
              :href="row.link"
              class="table-ellipsis__name linked-name"
            >
              <span :title="row.name">
                {{ row.name }}
              </span>
            </a>
          </td>
          <td>
            {{ row.id }}
          </td>
        </tr>
      </tbody>
    </v-table>
    <div
      class="pagination-min"
    >
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
        />
      </div>
    </div>
    
    <div
      v-if="getBuyerReferencesStatus.status === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'BUYER_REFERENCES_LOADING'" />
    </div>
    <div
        v-if="getBuyerReferencesStatus.status === 'success' && formattedReferences.length === 0"
        v-t="'BUYER_REFERENCES_EMPTY'"
        class="well well-sm text-center"
      />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import messages from '../locales';
import Loader from '@/core/components/Loader';
import { getStatus } from '@/store/helpers';
import { GET_BUYER_REFERENCES } from '../store/actionTypes';

export default {
  name: 'BuyerReferences',
  components: {
    Loader,
  },
  props: {
    buyerId: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      currentPage: 1,
      totalPages: 0,
    };
  },
  computed: {
    ...mapState('buyersV2', ['buyerReferences']),
    ...mapState('buyersV2', {
      getBuyerReferencesStatus: (state) => getStatus(state, GET_BUYER_REFERENCES) || {},
    }),
    
    formattedReferences() {
      if (!this.buyerReferences) return [];
      
      const references = [];
      const allTargets = this.buyerReferences.targets || [];
      
      allTargets.forEach(target => {
        const isRingTreeTarget = target.targetId && target.targetId.startsWith('PI');
        
        references.push({
          type: isRingTreeTarget ? 'Ring Tree Target' : 'Target',
          name: target.targetName || target.name || 'Unknown',
          id: target.targetId || target.id,
          link: isRingTreeTarget 
            ? '#/dashboard/ringtreetarget/edit/' + target.targetId
            : '#/dashboard/target/edit/' + target.targetId
        });
      });
      
      return references;
    },
  },
  created() {
    this[GET_BUYER_REFERENCES]({ buyerId: this.buyerId });
  },
  methods: {
    ...mapActions('buyersV2', [GET_BUYER_REFERENCES]),
    typeSort(a, b) {
      if (a.type === b.type) {
        if (a.name === b.name) {
          return 0;
        }
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      }
      if (a.type > b.type) {
        return 1;
      }
      return -1;
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>
